// Constants for ImageToText actions
export const IMAGE_TO_TEXT_FETCH_ALL_REQUEST = "IMAGE_TO_TEXT_FETCH_ALL_REQUEST";
export const IMAGE_TO_TEXT_FETCH_ALL_SUCCESS = "IMAGE_TO_TEXT_FETCH_ALL_SUCCESS";
export const IMAGE_TO_TEXT_FETCH_ALL_FAIL = "IMAGE_TO_TEXT_FETCH_ALL_FAIL";

export const IMAGE_TO_TEXT_FETCH_BY_ID_REQUEST = "IMAGE_TO_TEXT_FETCH_BY_ID_REQUEST";
export const IMAGE_TO_TEXT_FETCH_BY_ID_SUCCESS = "IMAGE_TO_TEXT_FETCH_BY_ID_SUCCESS";
export const IMAGE_TO_TEXT_FETCH_BY_ID_FAIL = "IMAGE_TO_TEXT_FETCH_BY_ID_FAIL";

export const IMAGE_TO_TEXT_DELETE_REQUEST = "IMAGE_TO_TEXT_DELETE_REQUEST";
export const IMAGE_TO_TEXT_DELETE_SUCCESS = "IMAGE_TO_TEXT_DELETE_SUCCESS";
export const IMAGE_TO_TEXT_DELETE_FAIL = "IMAGE_TO_TEXT_DELETE_FAIL";


// constants/creditConstants.js

export const IMAGE_TO_TEXT_CREDIT_GET_REQUEST = 'CREDIT_GET_REQUEST';
export const IMAGE_TO_TEXT_CREDIT_GET_SUCCESS = 'CREDIT_GET_SUCCESS';
export const IMAGE_TO_TEXT_CREDIT_GET_FAIL = 'CREDIT_GET_FAIL';
